<template>
    <v-container fluid>
        <v-card width="100%">
            <v-card-title class="justify-center pt-0 pb-2"><h2>Ask chat GPT a question</h2></v-card-title>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="1" class="pa-4">
                    <v-select v-model="model" :items="models" item-value="Option" item-text="Description" dense></v-select>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="6" class="pa-4">
                    <div class="mb-2">Ask chat gpt a question:</div>
                    <v-textarea v-model="question" rows="10" label="Question" variant="outlined" outlined></v-textarea>
                    <v-btn color="primary" small @click="getChatAnswer">Submit</v-btn>
                </v-col>
                <v-col cols="6" class="pa-4">
                    <div class="mb-2">Answer:</div>
                    <v-textarea ref="answer" v-on:focus="$event.target.select()" v-model="answer" rows="10" label="Answer" variant="outlined" outlined readonly></v-textarea>
                    <v-btn color="primary" small @click="copyText">copy</v-btn>
                </v-col>
            </v-row>
        </v-card>
        
        <!-- <v-row v-if="conversation_id!==''">
            <v-col cols="12" v-if="loading"><cardWait/></v-col>
            <v-col cols="4">
                <cardVirtualAssistantUpdate ref="cardVirtualAssistantUpdate" :assistant_id="assistant.id" v-if="!loading"/>
            </v-col>
            <v-col cols="8">
                <cardVirtualConversationTest ref="cardVirtualConversationTest" :conversation="conversation" :files="files" :hasBooking="conversation.metadata.huov_code!==''" :hasAcco="conversation.metadata.huis_code!==''" @updateData="getTestConversation" v-if="!loading"/>
            </v-col>
        </v-row> -->
        
    </v-container>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {
                loading: false,

                model: "gpt-4o-mini",
                question: "",
                answer: "",

                models: [],
            }
        },
        mounted() {
            this.getChatModels();
        },
        methods: {              
            getChatModels() {
                this.$axios.post("ares/json/ares/syst/openai/getChatModels.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getChatModels",
                    },
                    getChatModels: {
                        refresh: false,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.models = res.data.getChatModels;
                    }
                });
            },
            getChatAnswer() {
                this.answer = "";
                this.$axios.post("ares/json/ares/syst/openai/getChatAnswer.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getChatAnswer",
                    },
                    getChatAnswer: {
                        model: this.model,
                        question: this.question,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.loading = false;
                    } else {
                        this.answer = res.data.getChatAnswer;
                        this.loading = false;
                     }
                });

            },
            copyText() {
                this.$refs.answer.focus();
                //element.select();
                //element.setSelectionRange(0, 99999);
                document.execCommand('copy');
                // this.clipboard.writeText(this.answer);
                this.$store.dispatch("setSnackbar", {
                    showing: true,
                    text: "Answer copied to clipboard",
                    color: "success",
                });
            }
        }
    }
</script>
